import { useEffect, useState } from "react";
import { getStoredTheme, applyTheme, themes } from "../../utils/theme";

// Compact three-way theme switcher (system / light / dark) rendered as small
// icon buttons. Lives in the footer.
const OPTIONS = [
  { value: themes.SYSTEM, icon: "bi-circle-half", label: "Use system theme" },
  { value: themes.LIGHT, icon: "bi-sun", label: "Use light theme" },
  { value: themes.DARK, icon: "bi-moon-stars", label: "Use dark theme" },
];

export const ThemeToggle = ({ className = "" }) => {
  const [preference, setPreference] = useState(themes.DARK);

  useEffect(() => {
    setPreference(getStoredTheme());
  }, []);

  const handleSelect = (value) => setPreference(applyTheme(value));

  return (
    <div
      className={`theme-switch d-inline-flex align-items-center ${className}`}
      role="group"
      aria-label="Theme"
    >
      {OPTIONS.map(({ value, icon, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => handleSelect(value)}
          className={`theme-switch__option ${
            preference === value ? "is-active" : ""
          }`}
          aria-label={label}
          aria-pressed={preference === value}
          title={label}
        >
          <i className={`bi ${icon}`} aria-hidden="true"></i>
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
